export default class PatrolInterface {
  constructor(view, i18n) {
    this.view = view
    this.i18n = i18n
  }

  showMediaButton() {
    this.view.mediaButton.classList.remove("d-none")
  }

  hideMediaButton() {
    this.view.mediaButton.classList.add("d-none")
  }

  disableStopButton() {
    this.view.stopButton.disabled = true
  }

  enableStopButton() {
    this.view.stopButton.disabled = false
  }

  updateUploadStatus() {
    this.view.uploadStatus.innerHTML = `
      <div class="mb-2">
        <strong>${this.i18n.t("patrols.progressbar.total")}:</strong>
        <div class="progress">
          <div class="progress-bar" role="progressbar" style="width: 0%" 
                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
            0%
          </div>
        </div>
      </div>
      <div>
        <strong>${this.i18n.t("patrols.progressbar.current")}:</strong>
        <div class="progress">
          <div class="progress-bar" role="progressbar" style="width: 0%" 
                aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
            0%
          </div>
        </div>
      </div>
    `
  }

  updateCurrentFileProgress(progress) {
    const currentProgressBar = this.view.uploadStatus.querySelectorAll('.progress-bar')[1]
    currentProgressBar.style.width = `${progress}%`
    currentProgressBar.setAttribute('aria-valuenow', progress)
    currentProgressBar.textContent = `${Math.round(progress)}%`
  }

  updateTotalProgress(completed, total) {
    const progress = (completed / total) * 100
    const totalProgressBar = this.view.uploadStatus.querySelectorAll('.progress-bar')[0]
    totalProgressBar.style.width = `${progress}%`
    totalProgressBar.setAttribute('aria-valuenow', progress)
    totalProgressBar.textContent = `${Math.round(progress)}%`
  }
}
